/*
 * This file has some imports commented because when the generator runs they might not exist
 * You have to change ./mockErrorTypes import for @goodneighbor/api-client
 * then complete the list of errors
 * Read https://app.clickup.com/1274576/v/dc/16wpg-156274/16wpg-331954 for more details
 * */
// import type { ErrorContext } from '@goodneighbor/api-client';
import type { ErrorContext } from './mockErrorTypes';

// import { ErrorCode } from '@goodneighbor/api-client';
import { ErrorCode } from './mockErrorTypes';

type ErrorMessageContext<Code extends ErrorCode> =
  Code extends keyof ErrorContext ? ErrorContext[Code] : undefined;

// Separate the function types into required and optional context
type ErrorMessageRequiredContext<Code extends ErrorCode> = (
  context: ErrorMessageContext<Code>
) => string;
// eslint-disable-next-line @typescript-eslint/no-unused-vars,no-unused-vars
type ErrorMessageOptionalContext<Code extends ErrorCode> = () => string;

// Union type for error message functions
type ErrorMessage = {
  [Code in ErrorCode]: ErrorMessageContext<Code> extends undefined
    ? ErrorMessageOptionalContext<Code>
    : ErrorMessageRequiredContext<Code>;
};

// Since we are using msg() from macro
// when extract runs it creates the translation
// Dev must go to each language po (Except EN - sourceLanguage) file and add a translation
// sourceLanguage defined in lingui config will take the messages in here
const getErrorMessage = <Code extends ErrorCode>(
  error: Code
): ErrorMessage[Code] => {
  const errorMessages: ErrorMessage = {
    [ErrorCode.ANOTHER_CONTEXTUAL_ERROR]: ({ placeholder }) =>
      `Example of how to use props ${placeholder} in messages  from error.ts`,
    [ErrorCode.CUSTOM_CONTEXTUAL_ERROR]: ({ numberValue, stringValue }) =>
      `Example of how to use props ${numberValue} ${stringValue} in messages from error.ts`,
    [ErrorCode.UNEXPECTED_ERROR]: () => `Example of how to use without props`,
    [ErrorCode.TOKEN_EXPIRED_ERROR]: () => `Add all the ErrorCodes in this list`
  };

  return errorMessages[error];
};

export { getErrorMessage };
